
module Blocks {
    export interface IStorage extends ng.IModule { }

    export class Storage {
        static moduleId: string = 'blocks.sessionStorage';
    }

    // Create the module and define its dependencies.
    export var storage: IStorage = angular.module(Storage.moduleId, []);

    // Execute bootstrapping code and any dependencies.
    storage.run([() => { }]);
}
